var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from 'react';
import { Popover } from '../Popover';
import { Input } from '../Input';
import { ListItem, List } from '../List';
import { Tag } from '../Tag';
import { MdExpandMore, MdExpandLess, MdClose } from 'react-icons/md';
import { Button } from '../Button';
import { Skeleton } from '../Loading';
export class AutoComplete extends React.Component {
    constructor(props) {
        super(props);
        this.dataActualLength = 0;
        this.fetchData = () => __awaiter(this, void 0, void 0, function* () {
            const { data } = this.props;
            const { search } = this.state;
            let items = data(search);
            if (!Array.isArray(items)) {
                this.setState({ loading: true });
                items = yield items;
                this.setState({ loading: false });
            }
            this.dataActualLength = items.length;
            this.setState({ data: items });
        });
        this.onOpen = (open, callback) => {
            if (this.props.disabled) {
                return;
            }
            if (!open) {
                return this.setState({ open, selected: -1, search: '' }, callback);
            }
            open && this.fetchData();
            this.setState({ open }, callback);
        };
        this.displayList = () => {
            const { data, search, loading, selected } = this.state;
            const { listDisplayProp, uniqueIdentifier, searchValue } = this.props;
            let filteredData = data;
            if (searchValue) {
                filteredData = data === null || data === void 0 ? void 0 : data.filter((v) => searchValue(v).toLowerCase().includes(search.toLowerCase()));
            }
            this.dataActualLength = filteredData.length;
            return (React.createElement(Skeleton, { isLoading: loading, render: () => (React.createElement(List, { densed: true, style: { maxHeight: '300px', overflowY: 'auto' } }, filteredData === null || filteredData === void 0 ? void 0 : filteredData.map((v, i) => (React.createElement(ListItem, { key: uniqueIdentifier(v), selected: this.isItemSelected(v) || selected === i, onClick: () => this.onChange(v), onMouseEnter: () => this.setState({ selected: i }) }, listDisplayProp(v)))))) }));
        };
        this.isItemSelected = (current) => {
            const { uniqueIdentifier, value } = this.props;
            if (!value) {
                return false;
            }
            if (Array.isArray(value)) {
                return !!value.find((v) => uniqueIdentifier(v) === uniqueIdentifier(current));
            }
            return uniqueIdentifier(current) === uniqueIdentifier(value);
        };
        this.displayValue = () => {
            const { mode, displayValue, value } = this.props;
            const { open, search } = this.state;
            if (open) {
                return search;
            }
            if (mode === 'single') {
                return displayValue(value) || '';
            }
            return '';
        };
        this.renderBefore = () => {
            const { mode, displayValue, before, value, uniqueIdentifier } = this.props;
            if (mode === 'single') {
                return before;
            }
            return [
                before,
                ...value.map((v) => (React.createElement(Tag, { color: "#aaa", textColor: "light", onClick: () => this.onChange(v), outline: true, size: "SMALL", key: uniqueIdentifier(v) }, displayValue(v)))),
            ];
        };
        this.renderAfter = () => {
            const { open } = this.state;
            const { value, clearable, mode } = this.props;
            const afters = [
                React.createElement(Button, { key: "expand", flat: true, shape: "circle", icon: open ? React.createElement(MdExpandLess, { key: "expand" }) : React.createElement(MdExpandMore, { key: "expand" }), onClick: (e) => e.preventDefault() }),
            ];
            if ((mode === 'single' ? value : value.length) && clearable) {
                afters.push(React.createElement(Button, { onClick: (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        this.onChange(null);
                    }, key: "clear", flat: true, shape: "circle", icon: React.createElement(MdClose, null) }));
            }
            return afters.reverse();
        };
        this.onSearch = (search) => {
            if (!this.state.open) {
                return this.onOpen(true, () => this.onSearch(search.slice(-1)));
            }
            this.setState({ search }, this.fetchData);
        };
        this.onChange = (selected) => {
            const { mode, value, onChange, uniqueIdentifier } = this.props;
            if (mode === 'single') {
                onChange(selected);
                this.setState({ search: '' }, () => this.onOpen(false));
                return;
            }
            if (!selected) {
                return onChange([]);
            }
            const selectedValues = [...value];
            const index = selectedValues.findIndex((v) => uniqueIdentifier(v) === uniqueIdentifier(selected));
            index === -1 ? selectedValues.push(selected) : selectedValues.splice(index, 1);
            onChange(selectedValues);
            this.setState({ search: '' });
        };
        this.onKeyDown = (e) => {
            const { data, selected, open } = this.state;
            switch (e.key) {
                case 'Escape': {
                    return this.onOpen(false);
                }
                case 'ArrowDown': {
                    if (!open) {
                        return this.onOpen(true);
                    }
                    if (selected === this.dataActualLength - 1) {
                        return this.setState({ selected: -1 });
                    }
                    return this.setState({ selected: selected + 1 });
                }
                case 'ArrowUp': {
                    if (!open) {
                        return this.onOpen(true);
                    }
                    if (selected === -1) {
                        return this.setState({ selected: this.dataActualLength - 1 });
                    }
                    return this.setState({ selected: selected - 1 });
                }
                case 'Enter': {
                    e.preventDefault();
                    if (selected === -1) {
                        return;
                    }
                    return this.onChange(data[selected]);
                }
            }
        };
        this.state = {
            search: '',
            data: [],
            open: false,
            loading: false,
            selected: -1,
        };
    }
    render() {
        const { children, label, error, hint, required } = this.props;
        const { open } = this.state;
        const inputElem = React.cloneElement(children, {
            label,
            error,
            hint,
            after: this.renderAfter(),
            value: this.displayValue(),
            before: this.renderBefore(),
            onChange: (e) => this.onSearch(e.target.value),
            onKeyDown: this.onKeyDown,
            required,
            disabled: this.props.disabled,
        });
        return (React.createElement(Popover, { trigger: "onClick", position: "bottom", content: this.displayList(), onVisibleChange: (v) => this.onOpen(v), visible: open, expand: true, hideArrow: true, style: { child: { display: 'block' } } },
            React.createElement("div", null, inputElem)));
    }
}
AutoComplete.defaultProps = {
    children: React.createElement(Input, null),
    mode: 'single',
    clearable: true,
};
//# sourceMappingURL=AutoComplete.js.map